/* eslint-disable import/no-named-as-default */
import React from 'react';
import PropTypes from 'prop-types';
import FlatButton from 'material-ui/FlatButton';
import { isAlphaNumerical } from '../../utils/helper';


class EquipmentSerialTextBox extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.handleEquipmentChanged = this
      .handleEquipmentChanged
      .bind(this);
    this.reset = this
      .reset
      .bind(this);
  }
  reset(e) {
    e.preventDefault();
    const { orderId, workOrderActions, outlet } = this.props;
    workOrderActions.outletUpdate({
      orderId: orderId,
      newSerialNumber: outlet.get('originalSerialNumber'),
      outletId: outlet.get('equipmentOutlet')
    });
  }

  handleEquipmentChanged(e) {
    const { orderId, workOrderActions, outlet } = this.props;
    const newSerialNumber = e.target.value ? e.target.value.toUpperCase() : "";
    if (isAlphaNumerical(newSerialNumber) || newSerialNumber === "") {
      workOrderActions.outletUpdate({
        orderId: orderId,
        newSerialNumber: newSerialNumber,
        outletId: outlet.get('equipmentOutlet')
      });
    }
  }

  render() {
    const { outlet, disabled } = this.props;

    let resetButton = null;

    if (outlet.get('action') === 'add' || outlet.get('action') === 'update' || outlet.get('action') === 'remove') {
      resetButton = (<FlatButton primary label="Reset" onTouchTap={this.reset} />);
    }

    return (
      <div>
        <label style={{
          paddingRight: '10px'
        }}>Current:
        </label>
        {outlet.get('originalSerialNumber') || 'None'}

        {resetButton}
        <input
          disabled={disabled}
          className="browser-default"
          value={outlet.get('seriaNumber')}
          onChange={this.handleEquipmentChanged} /></div>
    );
  }
}

EquipmentSerialTextBox.propTypes = {
  outlet: PropTypes.object,
  orderId: PropTypes.string,
  workOrderActions: PropTypes.object,
  disabled: PropTypes.bool
};
export default EquipmentSerialTextBox;



// WEBPACK FOOTER //
// ./src/components/equipment/EquipmentSerialTextBox.js